import { Field } from '../../../../environments/field';
import { environment } from '../../../../environments/environment';

let token = sessionStorage.getItem('token');

export let fields: Array<Field> = [
  {
    type: 'text',
    name: 'nombre',
    label: 'Nombre',
    value: '',
    validfield: true,
    required: true,
    width: 'col-md-6',
  },
  {
    type: 'select',
    name: 'trabajador',
    label: 'Cedis',
    value: '',
    validfield: true,
    required: true,
    width: 'col-md-6',
    api:'cedis'
  },

  ];
